import kr from '../../kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class FullVideoProduct extends kr.Component {
    init() {
        this._js = "https://cdn.jsdelivr.net/npm/youtube-background@1.0.8/jquery.youtube-background.min.js";

        this._el = this.$element.querySelector('[data-youtube]');
        this.bind();
    }

    bind() {
        this.on('click', '.js-productFullVideoStart', (target, event) => {
            event.preventDefault();
            this.app.addJs(this._js, this, this._callback.bind(this));
        });
    }

    _callback() {
        HTMLClass.addClass(this.$element, 'video--started')
        jQuery(this._el).youtube_background();
    }
}

kr.registerComponent('.js-productFullVideo', {
    component: FullVideoProduct
});
